import {isValidationError} from "../../utils/isValidationError";
import {RegistrationErrorKind} from "../types/RegistrationErrorKind";

const EXISTING_ACCOUNT_MESSAGE_PATTERN = /istnieje/i;

const isForbiddenError = (error: unknown) => {
    if (typeof error !== "object" || error === null) {
        return false;
    }

    if ("response" in error && (error as {response?: {status?: number}}).response?.status === 403) {
        return true;
    }

    return "status" in error && (error as {status?: unknown}).status === 403;
};

export const getRegistrationErrorKind = (error: unknown): RegistrationErrorKind => {
    if (isValidationError(error) && error.appError.fieldErrors.phone?.length) {
        return "phone_invalid";
    }

    if (isForbiddenError(error)) {
        return "forbidden";
    }

    if (!isValidationError(error)) {
        return "unknown";
    }

    const emailErrors = error.appError.fieldErrors.email;
    const emailMessages = Array.isArray(emailErrors) ? emailErrors : emailErrors ? [emailErrors] : [];

    if (emailMessages.some((message) => EXISTING_ACCOUNT_MESSAGE_PATTERN.test(message))) {
        return "existing_account";
    }

    return emailErrors ? "email_invalid" : "unknown";
};
import {isValidationError} from "../../utils/isValidationError";
import {RegistrationErrorKind} from "../types/RegistrationErrorKind";

const EXISTING_ACCOUNT_MESSAGE_PATTERN = /istnieje/i;

const isForbiddenError = (error: unknown) => {
    if (typeof error !== "object" || error === null) {
        return false;
    }

    if ("response" in error && (error as {response?: {status?: number}}).response?.status === 403) {
        return true;
    }

    return "status" in error && (error as {status?: unknown}).status === 403;
};

export const getRegistrationErrorKind = (error: unknown): RegistrationErrorKind => {
    if (isValidationError(error) && error.appError.fieldErrors.phone?.length) {
        return "phone_invalid";
    }

    if (isForbiddenError(error)) {
        return "forbidden";
    }

    if (!isValidationError(error)) {
        return "unknown";
    }

    const emailErrors = error.appError.fieldErrors.email;
    const emailMessages = Array.isArray(emailErrors) ? emailErrors : emailErrors ? [emailErrors] : [];

    if (emailMessages.some((message) => EXISTING_ACCOUNT_MESSAGE_PATTERN.test(message))) {
        return "existing_account";
    }

    return emailErrors ? "email_invalid" : "unknown";
};
